const clone = dolly => JSON.parse(JSON.stringify(dolly));

const cloneAndClean = dolly => {
    let cloned = clone(dolly);
    Object.keys(cloned).forEach((key) => (cloned[key] === null || cloned[key] === undefined || cloned[key] === false || Array.isArray(cloned[key]) && cloned[key].length === 0) && delete cloned[key]);
    return cloned;
}

export { clone, cloneAndClean }
